/* eslint-disable */

import Api from "../../lib/api";
import { createSlice } from "@reduxjs/toolkit";
import { editEntity } from "../shared/api";
import { mapResourceObjectToArray } from "../../utils/jsonApiUtils";
import { setMessage } from "../shared/notification/slice";
import { sortPointsByPosition } from "./utils";

export const sliceName = "activeTrip";

const initialState = {
    data: {},
    drivers: {},
    trucks: {},
    suppliers: {},
    tripPoints: {},
    attachments: {},
    tripType: {},
    truckTypes: {},
    branches: {},
    assignees: {},
    comments: {},
    confirmedTrips: {},
    projects: {},
    meta: {},
    isLoading: false,
    hasErrors: false,
};

const activeTripSlice = createSlice({
    name: sliceName,
    initialState,
    reducers: {
        getActiveTrip: (state) => {
            state.isLoading = true;
        },
        getActiveTripSuccess: (state, { payload }) => {
            const { entities } = payload;
            state.data = entities.trips;
            state.drivers = entities.drivers;
            state.trucks = entities.trucks;
            state.orders = entities.orders;
            state.suppliers = entities.suppliers;
            state.tripPoints = entities.tripPoints;
            state.attachments = entities.attachments;
            state.tripTypes = entities.tripTypes;
            state.truckType = entities.truckTypes;
            state.tripPrice = entities.tripPrices;
            state.branches = entities.branches;
            state.comments = entities.comments;
            state.confirmedTrips = entities.confirmTrips;
            state.projects = entities.projects;
            state.admins = entities.adminUsers;
            state.meta = entities.meta;
            state.hasErrors = false;
            state.isLoading = false;
        },
        getActiveTripFailure: (state) => {
            state.hasErrors = true;
            state.isLoading = false;
        },
        editTrip: (state, { payload }) => {
            state.isLoading = true;
        },
        editTripSuccess: (state, { payload }) => {
            state.hasErrors = false;
            state.isLoading = false;
        },
        editTripFailure: (state, { payload }) => {
            state.hasErrors = true;
            state.isLoading = false;
        },
        getActiveTripAssignees: (state, { payload }) => {
            state.isLoading = true;
        },
        getActiveTripAssigneesSuccess: (state, { payload }) => {
            const { entities } = payload;
            state.assignees = entities.adminUsers;
            state.hasErrors = false;
            state.isLoading = false;
        },
        getActiveTripAssigneesFailure: (state, { payload }) => {
            state.hasErrors = true;
            state.isLoading = false;
        },
    },
});

export default activeTripSlice.reducer;

export const {
    getActiveTrip,
    getActiveTripSuccess,
    getActiveTripFailure,
    editTrip,
    editTripSuccess,
    editTripFailure,
    getActiveTripAssignees,
    getActiveTripAssigneesFailure,
    getActiveTripAssigneesSuccess,
} = activeTripSlice.actions;

export const activeTripSelector = () => (state) => state[sliceName].data;
// console.log(state[sliceName].data)

export const driverSelector = () => (state) => state[sliceName].drivers;
export const truckSelector = () => (state) => state[sliceName].trucks;
export const truckTypeSelector = () => (state) => state[sliceName].truckType;
export const tripPriceSelector = () => (state) => state[sliceName].tripPrice;
export const ordersSelector = () => (state) => state[sliceName].orders;
export const suppliersSelector = () => (state) => state[sliceName].suppliers;
export const commentsSelector = () => (state) => state[sliceName].comments;
export const pointsSelector = () => (state) =>
    sortPointsByPosition(mapResourceObjectToArray(state[sliceName].tripPoints));
export const confirmedTripsSelector = () => (state) =>
    mapResourceObjectToArray(state[sliceName].confirmedTrips);
export const projectsSelector = () => (state) => state[sliceName].projects;
export const adminsSelector = () => (state) => mapResourceObjectToArray(state[sliceName].admins);
export const pointsAttachmentsSelector = () => (state) => state[sliceName].attachments;
export const tripTypesSelector = () => (state) => state[sliceName].tripTypes;
export const branchesSelector = () => (state) => state[sliceName].branches;
export const assigneesSelector = () => (state) => state[sliceName].assignees;
export const isLoadingSelector = () => (state) => state[sliceName].isLoading;

export function fetchTrip(id, includedEntities) {
    return async (dispatch) => {
        dispatch(getActiveTrip());

        try {
            const response = await Api.get(`/trips/${id}`, {
                params: {
                    include: includedEntities,
                },
            });

            dispatch(getActiveTripSuccess({ ...response }));
        } catch (error) {
            dispatch(getActiveTripFailure({ error }));
            dispatch(
                setMessage({
                    content: error,
                    title: `Couldn't fetch trip ${id} from the server`,
                    isError: true,
                })
            );
        }
    };
}

export function fetchTripAssignees(id) {
    return async (dispatch) => {
        dispatch(getActiveTripAssignees());

        try {
            const response = await Api.get(`/trips/${id}`, {
                params: {
                    include: "assignees",
                },
            });
            dispatch(getActiveTripAssigneesSuccess({ ...response }));
        } catch (error) {
            dispatch(getActiveTripAssigneesFailure({ error }));
            dispatch(
                setMessage({
                    content: error,
                    title: `Couldn't fetch trip ${id} from the server`,
                    isError: true,
                })
            );
        }
    };
}

export const updateActiveTrip = (entityObject, updatedData, intl) => {
    return editEntity(entityObject, updatedData, editTrip, editTripSuccess, editTripFailure, intl);
};
